export const SET_ActiveLink = 'SET_ActiveLink';

export const SET_DISPLAY_OFF = 'SET_DISPLAY_OFF';

export const LOGOUT='LOGOUT';